import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from './loader.service';
import { NotificationService } from './notification.service';

export type SessionExpiredReason =
  | 'REFRESH_FAILED'      // Keycloak rechazó updateToken (refresh token expirado/revocado)
  | 'RETRY_UNAUTHORIZED'  // Refresh OK pero el reintento devolvió 401 (usuario revocado/roles cambiados)
  | 'UNAUTHENTICATED';    // 401 sin posibilidad de refresh (sin token)

const HOME_ROUTE = '/home';

@Injectable({
  providedIn: 'root'
})
export class SessionExpiredService {

  private handling = false;

  constructor(
    private readonly router: Router,
    private readonly notification: NotificationService,
    private readonly loaderService: LoaderService
  ) {}

  handle(reason: SessionExpiredReason, originalError?: unknown): void {
    if (this.handling) {
      return;
    }
    this.handling = true;

    // Telemetría estructurada — pieza clave para detectar regresiones / Keycloak degradado en prod
    // eslint-disable-next-line no-console
    console.warn('[SessionExpired]', { reason, url: this.router.url, error: originalError });

    const returnUrl = this.captureReturnUrl();

    this.clearAuthStorage();

    this.notification.alert(
      'Sesión expirada',
      'Tu sesión ha caducado o ya no es válida. Vuelve a iniciar sesión para continuar.',
      'warning'
    );

    this.loaderService.hide();

    this.router.navigate([HOME_ROUTE], {
      queryParams: returnUrl ? { returnUrl } : {}
    });
  }

  /** Permite forzar reset (p.ej. tras login exitoso) por si el flag quedó pegado. */
  reset(): void {
    this.handling = false;
  }

  private captureReturnUrl(): string | null {
    const current = this.router.url;
    if (!current || current === '/' || current.startsWith(HOME_ROUTE)) {
      return null;
    }
    return current;
  }

  private clearAuthStorage(): void {
    // Conservar returnUrl en queryParam evita necesidad de preservar claves específicas
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch {
      // Storage puede no estar disponible (modo privado, cuota, etc.) — no es crítico
    }
  }
}
